<script setup lang="ts">
import { ref } from 'vue'
import { useAuthStore } from '../../stores/auth'
import ConfirmDialog from '../app/ConfirmDialog.vue'
import LoginScreen from './LoginScreen.vue'
import LocalDeviceActions from './LocalDeviceActions.vue'
const auth = useAuthStore()
const password = ref('')
const unlockError = ref<string | null>(null)
const onlineSignIn = ref(false)
async function unlock() {
  unlockError.value = null
  try { await auth.unlockKeySession(password.value); password.value = '' }
  catch (cause) { unlockError.value = cause instanceof Error ? cause.message : String(cause) }
}
</script>
<template>
  <div v-if="!onlineSignIn" class="local-unlock">
    <main class="local-unlock-card settings-modal">
      <h1>Unlock local writing</h1>
      <p>Your writing is locked on this device. No internet connection is needed to unlock.</p>
      <p>Use the last password signed in here. A password changed on another device takes effect here after a successful online sign-in.</p>
      <form @submit.prevent="unlock">
        <label>Password <input v-model="password" class="s-input" type="password" autocomplete="current-password" autofocus :disabled="auth.loading" /></label>
        <button class="s-btn" type="submit" :disabled="!password || auth.loading">{{ auth.loading ? 'Unlocking…' : 'Unlock locally' }}</button>
      </form>
      <p v-if="unlockError" class="s-note error" role="alert">{{ unlockError }}</p>
      <button class="s-btn" type="button" :disabled="auth.loading" @click="onlineSignIn = true">Sign in online instead…</button>
      <LocalDeviceActions />
    </main>
  </div>
  <ConfirmDialog v-if="!onlineSignIn" />
  <template v-if="onlineSignIn">
    <LoginScreen />
    <button class="return-local s-btn" type="button" @click="onlineSignIn = false">Back to local unlock</button>
  </template>
</template>
<style scoped>
.local-unlock { min-height: 100vh; display: grid; place-items: center; padding: 24px; box-sizing: border-box; background: var(--bg-color); color: var(--text-normal); font-family: var(--ui-text); }
.local-unlock-card { width: min(480px, 100%); padding: 24px; border: 1px solid var(--surface-border); border-radius: 14px; background: var(--surface-bg); }
h1 { font-family: var(--ui-display); font-size: 24px; }
p { line-height: 1.5; }
form { display: flex; flex-direction: column; gap: 12px; margin: 20px 0; }
label { display: flex; flex-direction: column; gap: 8px; }
.return-local { position: fixed; bottom: 20px; left: 20px; z-index: 100000; }
</style>
